var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{attrs:{"src":"https://cdn.ccli.com/logos/ccli/ccli-1-color-all-white.svg","width":"90","alt":_vm.$t('G.LIT_CCLITrademarkLogo')}})
}
var staticRenderFns = []

export { render, staticRenderFns }